
module.exports = {
  dataAssettypes: require('./assettypes'),
  dataAssetClasses: require('./assetclasses'),
  dataManufactures: require('./manufactures')
}